<mat-toolbar class="my-navbar-darkColor " style="height: 65px;"
  [ngClass]="{'background-test':isTest}"

  >
  <mat-toolbar-row>
    <div style="display: flex;align-items: center;justify-content: space-between;width: calc(100% - 32px)">
      <div style="display: flex;align-items: center;justify-content: space-between;">
        <button mat-flat-button [matMenuTriggerFor]="menuPrincipal" [disabled]="disabledMenu"
          style="background: unset">
          <img [src]="getUrlLogo()"
            class="huna-logo-size">
        </button>
      </div>
      <!--            sezione centrale navbar-->
      <div class="truncate">{{ nameProject }}</div>
      <app-setting-option-button [currentUrl]="currentUrl"
        [isSystemAdmin]="(isSystemAdmin$|async)!">

      </app-setting-option-button>
      <!--            <div>-->
      <!--                <button mat-icon-button color="primary" [matMenuTriggerFor]="projectList" [disabled]="disabledProject">-->
      <!--                    <mat-icon class="example-icon">-->
      <!--                        assignment-->
    <!--                    </mat-icon>-->
  <!--                </button>-->
  <!--                <button mat-icon-button [matMenuTriggerFor]="menuProfile">-->
  <!--                    <mat-icon color="primary" class="example-icon">-->
  <!--                        account_circle-->
<!--                    </mat-icon>-->
<!--                </button>-->
<!--                <button mat-icon-button [matMenuTriggerFor]="language" matTooltip="{{'selectLanguage'|translate}}"-->
<!--                        style="margin-top: -3px;">-->
<!--                    <img src="assets/icon/flags/{{iconLanguage+'.svg'}}" color="primary" class="example-icon"-->
<!--                         class="img-icon">-->
<!--                </button>-->
<!--            </div>-->
</div>
</mat-toolbar-row>
</mat-toolbar>
<mat-menu #menuPrincipal="matMenu" class="my-class">
  <div class="menu-width">
    @for (link of links; track link) {
      <a mat-menu-item routerLink="{{link.path}}">
        @if (link.iconCustom) {
          <mat-icon>
            <img src="{{link.iconCustom}}" style=";max-width: 24px;" class="invert-color-dark-theme">
          </mat-icon>
        } @else {
          @if (link.icon) {
            <mat-icon
              [color]="link|transformValueByPredicateFunction:getColorIconNotificationsPredicate:toRead"
              >{{ link.icon }}
            </mat-icon>
          }
        }
        {{ link.title | translate }}
      </a>
    }
  </div>
</mat-menu>
<!--<mat-menu #projectList="matMenu">-->
<!--    <div mat-menu-item style="text-align: center;" (click)="selectProject(project)" *ngFor="let project of allProject">-->
<!--        <p>{{project.name}}</p>-->
<!--    </div>-->
<!--</mat-menu>-->
<!--<mat-menu #menuProfile="matMenu">-->
<!--    <p [disabled]="true" mat-menu-item>{{'welcome' | translate:{name: nameUser} }}</p>-->
<!--    <a mat-menu-item [routerLink]="'/user/account'">-->
<!--        <mat-icon>edit</mat-icon>-->
<!--        <span>{{'edit_profile' | translate}}</span>-->
<!--    </a>-->
<!--    <a mat-menu-item (click)="logout()">-->
<!--        <mat-icon>exit_to_app</mat-icon>-->
<!--        <span>{{'exit' | translate}}</span>-->
<!--    </a>-->
<!--    <div>-->
<!--        <button mat-menu-item (click)="darkModeChangeValue(!darkModeOn);">-->
<!--            <mat-slide-toggle style="opacity: 1!important;"-->
<!--                              [disabled]="true"-->
<!--                              [checked]="darkModeOn">{{'darkMode'|translate}}</mat-slide-toggle>-->
<!--        </button>-->
<!--    </div>-->
<!--    <div class="flex-end-center" >-->
<!--        <img src="assets/icon/hamburgerNavbar/version.png" class="img-icon-M">-->
<!--        <span style="margin: 0 10px;font-weight: 500;" class="text-color-default">{{versioneSoftware}}</span>-->
<!--    </div>-->
<!--</mat-menu>-->
<!--<mat-menu #language="matMenu">-->
<!--    <div mat-menu-item style="text-align: center;" (click)="setLanguage('it')">-->
<!--        <button mat-icon-button matTooltip="Italiano">-->
<!--            <img src="assets/icon/flags/it.svg" color="primary" class="example-icon" class="img-icon">-->
<!--        </button>-->
<!--    </div>-->
<!--    <div mat-menu-item style="text-align: center;" (click)="setLanguage('ca')">-->
<!--        <button mat-icon-button matTooltip="Català">-->
<!--            <img src="assets/icon/flags/ca.svg" color="primary" class="example-icon" class="img-icon">-->
<!--        </button>-->
<!--    </div>-->
<!--    <div mat-menu-item style="text-align: center;" (click)="setLanguage('es')">-->
<!--        <button mat-icon-button matTooltip="Español">-->
<!--            <img src="assets/icon/flags/es.svg" color="primary" class="example-icon" class="img-icon">-->
<!--        </button>-->
<!--    </div>-->
<!--    <div mat-menu-item style="text-align: center;" (click)="setLanguage('en')">-->
<!--        <button mat-icon-button matTooltip="English">-->
<!--            <img src="assets/icon/flags/en.svg" color="primary" class="example-icon" class="img-icon">-->
<!--        </button>-->
<!--    </div>-->
<!--</mat-menu>-->
